import { Box, Typography, styled, Button } from "@mui/material";
import { useNavigate } from "react-router-dom";

const Container = styled(Box)(({ theme }) => ({
  height: "100vh",
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  justifyContent: "center",
  backgroundColor: "#f5f5f5",
  gap: theme.spacing(4),
}));

const MessageText = styled(Typography)(({ theme }) => ({
  fontSize: "24px",
  color: "#333",
  textAlign: "center",
  [theme.breakpoints.down("sm")]: {
    fontSize: "20px",
    padding: "0 16px",
  },
}));

const HomeButton = styled(Button)(({ theme }) => ({
  minWidth: "150px",
  padding: "10px 20px",
  fontSize: "16px",
  [theme.breakpoints.down("sm")]: {
    minWidth: "120px",
    padding: "8px 16px",
    fontSize: "14px",
  },
}));

function ExamResultPage() {
  const navigate = useNavigate();

  const handleGoHome = () => {
    navigate("/home");
  };

  return (
    <Container>
      <MessageText>
        Results will be sent back to you within 2-3 days.
      </MessageText>
      <HomeButton variant="contained" color="primary" onClick={handleGoHome}>
        GO BACK TO HOMEPAGE
      </HomeButton>
    </Container>
  );
}

export default ExamResultPage;
